@let netSheetEnabled = netSheetEnabled$ | async;

<div class="tw:h-full tw:max-w-full tw:overflow-x-scroll">
  <div class="tw:relative tw:z-10 tw:flex tw:flex-none tw:justify-between tw:bg-white tw:px-10 tw:shadow-sm">
    <div class="tw:relative tw:h-16 tw:w-36 tw:px-0.5">
      <img priority alt="Application Logo" class="tw:object-contain" ngSrc="{{ logoUrl }}" fill />
    </div>
    <div class="tw:flex tw:items-center">
      <a
        class="tw:mx-8 tw:flex tw:flex-col tw:items-center"
        [routerLink]="['/', availableTabs.PropertySearch]"
        (click)="setCurrentTab(availableTabs.PropertySearch)"
      >
        <ion-icon
          size="large"
          [src]="
            activeTab === availableTabs.PropertySearch ? '/assets/svg/home-active.svg' : '/assets/svg/home-inactive.svg'
          "
        ></ion-icon>
        <ion-label class="tw:text-xs">Search</ion-label>
      </a>

      @if (walkingFarmEnabled$ | async) {
        <a
          class="tw:mx-8 tw:flex tw:flex-col tw:items-center"
          [routerLink]="['/', availableTabs.WalkingFarm]"
          (click)="setCurrentTab(availableTabs.WalkingFarm)"
        >
          <ion-icon
            size="large"
            [src]="
              activeTab === availableTabs.WalkingFarm
                ? '/assets/svg/walking-farm-active.svg'
                : '/assets/svg/walking-farm-inactive.svg'
            "
          ></ion-icon>
          <ion-label class="tw:text-xs">Walking Farm&#174;</ion-label>
        </a>
      }

      @if ((calculatorsEnabled$ | async) && netSheetEnabled === false) {
        <a
          class="tw:mx-8 tw:flex tw:flex-col tw:items-center"
          [routerLink]="['/', availableTabs.Calculators]"
          (click)="setCurrentTab(availableTabs.Calculators)"
        >
          <ion-icon
            size="large"
            [src]="
              activeTab === availableTabs.Calculators
                ? '/assets/svg/calculators-active.svg'
                : '/assets/svg/calculators-inactive.svg'
            "
          ></ion-icon>
          <ion-label class="tw:text-xs">Calculators</ion-label>
        </a>
      }

      @if (netSheetEnabled) {
        <a
          class="tw:mx-8 tw:flex tw:flex-col tw:items-center"
          [routerLink]="['/', availableTabs.NetSheet]"
          (click)="setCurrentTab(availableTabs.NetSheet)"
        >
          <ion-icon
            size="large"
            [src]="
              activeTab === availableTabs.NetSheet
                ? '/assets/svg/net-sheet-active.svg'
                : '/assets/svg/net-sheet-inactive.svg'
            "
          ></ion-icon>
          <ion-label class="tw:text-xs">Net Sheet</ion-label>
        </a>
      }

      <a
        class="tw:mx-8 tw:flex tw:flex-col tw:items-center"
        [routerLink]="['/', availableTabs.More]"
        (click)="setCurrentTab(availableTabs.More)"
      >
        <ion-icon
          size="large"
          [src]="activeTab === availableTabs.More ? '/assets/svg/more-active.svg' : '/assets/svg/more-inactive.svg'"
        ></ion-icon>
        <ion-label class="tw:text-xs">More</ion-label>
      </a>
    </div>
  </div>
  @let hasPropertyNavigation = propertyNavigationEnabled$ | async;
  <div class="web-page-container" [ngClass]="{ 'has-property-navigation': hasPropertyNavigation }">
    <div class="tw:relative tw:z-0 tw:h-full">
      <ion-router-outlet></ion-router-outlet>
    </div>
  </div>
  <div id="main-footer" class="tw:relative tw:z-10 tw:flex-none tw:bg-white tw:shadow-sm">
    @if (hasPropertyNavigation) {
      <red-property-navigator
        [walkingFarmId]="propertyNavigationWalkingFarmId"
        [propertyId]="propertyNavigationPropertyId"
      ></red-property-navigator>
    }
    <red-contact-card-content class="tw:pt-2"></red-contact-card-content>
  </div>
</div>
